import { DebidaDiligencia } from './debida-diligencia.model';
import { Direccion } from './direccion.model';
import { DocumentoDeIdentidad } from './documento-de-identidad.model';
import { Profesion } from './profesion.model';
import { SectorActividad } from './sector-actividad.model';
import { Pais } from './pais.model';
import { PersonaFisica } from './persona-fisica.model';
import { PersonaJuridica } from './persona-juridica.model';
import { SujetoObligado } from './sujeto-obligado.model';


export class Cliente
{
    id: number;
    uuid: string;
    active: number;
    tipo: any;
    sujetoObligado: SujetoObligado;
    personaFisica: PersonaFisica;
    personaJuridica: PersonaJuridica;
    externalId: string;
    token: string;
    tokenValidoHasta: Date;
    nombre: string;
    
    /**
     * Constructor
     *
     * @param cliente
     */
    constructor(cliente)
    {
        {
            this.id = cliente.id;
            this.uuid = cliente.uuid;
            this.tipo = cliente.tipo;
            this.active = cliente.active || 0;
            this.externalId = cliente.externalId || '';
            this.nombre = cliente.nombre || '';
            this.personaFisica = cliente.personaFisica || new PersonaFisica({});
            this.personaJuridica = cliente.personaJuridica || new PersonaJuridica({});
            this.sujetoObligado = cliente.sujetoObligado || new SujetoObligado({});
            
        }
    }
}
